import React from 'react';

export const RenderPD = ({ color, x, y, scale = 0.05, side = 'A', rotate = 0 }) => {
  return (
    <g transform={`translate(${x},${y}) scale(${scale}) rotate(${rotate})`}>
      <g style={{ transformOrigin: '0px 150px' }}>

        <path
          d="M-350,-150 L-350,150 L-130,150 L-20,60 L350,60 L350,0 L350,-60 L-20,-60 L-130,-150 L-350,-150 L-350,-100 L-350,100"
          style={{
            fill: color,
            stroke: 'rgb(0, 0, 0)',
            strokeLinejoin: 'round',
            strokeWidth: '8px'
          }}
        />

        <path
          d="M-130,-100 C-115,-85 -100,-70 -88,-52 C-82,-43 -76,-34 -72,-24 C-68,-14 -65,-4 -65,0 C-65,4 -68,14 -72,24 C-76,34 -82,43 -88,52 C-100,70 -115,85 -130,100 L-350,100 L-350,-100 L-130,-100"
          style={{
            fill: color,
            stroke: 'rgb(0, 0, 0)',
            strokeLinejoin: 'round',
            strokeWidth: '4px'
          }}
        />

        <rect
          x={-20} y={-60} width={370} height={120}
          style={{
            fill: 'rgb(191,191,191)',
            stroke: 'rgb(0, 0, 0)',
            strokeLinejoin: 'round',
            strokeWidth: '8px'
          }}
        />
      </g>
    </g>
  );
};

